export default __webpack_public_path__ + "static/media/multisolutions_logo-removebg-preview.981cf018.png";